<template>
    <span
        :class="active(arrowUpIcon)"
        class="btn btn-sm btn-info open-offer"
    >
        <i
            v-show="arrowDownIcon"
            class="fa fa-caret-down"
        ></i>
        <i
            v-show="arrowUpIcon"
            class="fa fa-caret-up"
        ></i>
        <i
            v-show="refreshIcon"
            class="fa fa-refresh fa-spin"
        ></i>
        <span class="sr-only">Show</span>
    </span>
</template>

<script>
export default {
    props: {
        refreshIcon: Boolean,
        arrowDownIcon: Boolean,
        arrowUpIcon: Boolean,
    },
    methods: {
        active: function (val) {
            return val ? 'active' : '';
        },
    },
};
</script>
